import React, { useCallback, useState } from "react";
import { getShipmentDetailsDocument } from "../../../../services/shipments";
import { useFetch } from "../../../../utils/hooks";
import "./DocumentPane.scss";
import { Spin, Button } from "antd";
import { ReactSVG } from "react-svg";
import { getIcon, getPanesIcon } from "../../../../utils/images";
import UploadModal from "../../../Modals/UploadModal/UploadModal";

const DocumentCard = ({ document }) => {
  return (
    <div className="DocumentCard">
      <div className="content-wrapper">
        <div className="content">
          {document.name}
        </div>
        <div>
          <a href={document.url} download={document.name} target="_blank">
            <img src={getIcon('download')} />
          </a>
        </div>
      </div>
    </div>
  )
}

const DocumentPane = ({ shipment }) => {
  const { data, loading, refetch } = useFetch(useCallback(() => getShipmentDetailsDocument(shipment.id), [shipment.id]))
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const documents = data?.documents || [];

  const handleCancel = () => {
    setIsUploadModalOpen(false);
    refetch();
  };

  const openUploadModal = () => {
    setIsUploadModalOpen(true)
  }

  if (loading) {
    return <Spin size="large" className="spinner" />
  }

  return (
    <div className="DocumentPane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('documents')} />
        <div className="pane__title">Documents</div>
      </div>
      <div className="pane__wrapper">
        <div className="pane__actions">
          <Button
            type="primary"
            onClick={openUploadModal}
          >
            Upload Documents
          </Button>
        </div>
        {documents?.map((document, index) => <DocumentCard key={index} document={document} />)}
      </div>
      <UploadModal shipment={shipment} isOpen={isUploadModalOpen} handleCancel={handleCancel}/>
    </div>
  )
}

export default DocumentPane;
